/**
 * Bottom clearance applied to scrollable page content on mobile so the last rows
 * are not hidden behind the fixed bottom action/navigation bar. Compose it into a
 * responsive value per page (e.g. `pb={{ base: MOBILE_BOTTOM_BAR_CLEARANCE, md: 0 }}`),
 * since desktop padding differs by layout.
 */
export const MOBILE_BOTTOM_BAR_CLEARANCE = '96px';

/**
 * Bottom clearance for a page whose composer bar is docked at the foot of the viewport. Matches the
 * dock's own desktop fade height, so the last row of a list clears the bar rather than dissolving
 * under it — pages that want content to run beneath the bar use their own smaller padding instead.
 */
export const COMPOSER_DOCK_CLEARANCE = '96px';

/**
 * Minimum interactive size for comfortable touch targets (Apple HIG / WCAG ~44px). Prefer spreading
 * {@link TOUCH_TARGET_MIN_H} over hand-writing the responsive object; this raw value is for one-off
 * sizing (e.g. width, or a non-button control).
 */
export const MIN_TOUCH_TARGET = '44px';

/**
 * Mobile-only `minH` floor for controls that otherwise render below the touch-target minimum — e.g.
 * the default `md` (40px) buttons used across settings. Spread it (`minH={TOUCH_TARGET_MIN_H}`)
 * rather than inlining the object: the `md: 'auto'` reset is mandatory because a bare `{ base }`
 * cascades to every breakpoint, so without it desktop inherits the taller floor too.
 */
export const TOUCH_TARGET_MIN_H = { base: MIN_TOUCH_TARGET, md: 'auto' } as const;
